<div class="policy-details-container">
  <div class="header-container mb-2">
    <span>
      <h1 class="col-12 mb-2"> Annuity Policy Details </h1>
    </span>

    <button
      type="button"
      mat-stroked-button
      color="primary"
      class="mb-2"
      (click)="printPolicy()"
    >
      <mat-icon>insert_drive_file</mat-icon> Print Policy Details
    </button>
  </div>
  <div class="action-buttons-container mb-2">
    <button
      type="button"
      class="nav-back-button"
      mat-button
      color="primary"
      (click)="nav('book-management')"
    >
      <mat-icon>arrow_back_ios</mat-icon> Back to Book Management
    </button>
    @if (launchButton && launchButton.ShowLaunchButton) {
      <button
        type="button"
        mat-flat-button
        color="accent"
        class="launch-aw-button"
        (click)="launchToCase(launchButton.LaunchLocation)"
      >
        <mat-icon>rocket_launch</mat-icon>{{ launchButton.LaunchButtonLabel }}
      </button>
    }
  </div>

  @for (policyRow of policyDetails; track policyRow.title) {
    @if (showCard(policyRow)) {
      <div class="info-card mt-4">
        <div class="card-header">
          <span class="card-title mb-0"> {{ policyRow.title }} </span>
        </div>

        <div
          class="policy-tables {{
            policyRow.tables.length > 1 ? 'multi-table' : ''
          }}"
        >
          @for (policyTable of policyRow.tables; track policyTable) {
            <div
              class="policy-table-container tables{{
                policyRow.tables.length
              }} {{
                policyTable.tableType === 'datapoints' ||
                policyTable.tableType === 'policies'
                  ? 'no-scroll'
                  : ''
              }}"
            >
              @switch (policyTable.tableType) {
                @case ('datapoints') {
                  <div class="card-info row">
                    @for (
                      tableHeader of policyTable.headers;
                      track tableHeader.label
                    ) {
                      @if (
                        policyTable.data[0][tableHeader.key] &&
                        !tableHeader.hide
                      ) {
                        <div
                          class="col-sm-{{ policyTable.cols || '4' }} col-12"
                        >
                          <div class="card-info-label">
                            {{ tableHeader.label }}
                          </div>
                          <div class="card-info-value mb-2">
                            @if (
                              tableHeader.valueMask &&
                              tableHeader.valueMask === 'decrypt'
                            ) {
                              <div class="decrypt-field">
                                {{ policyTable.data[0][tableHeader.key] }}
                                <button
                                  type="button"
                                  color="primary"
                                  class="ms-1"
                                  matIconButton
                                  matTooltip="View raw value"
                                  [matTooltipPosition]="'above'"
                                  (click)="
                                    viewRawValue(
                                      policyTable.data[0][
                                        tableHeader.maskTarget
                                      ]
                                    )
                                  "
                                >
                                  <mat-icon>lock_open</mat-icon>
                                </button>
                              </div>
                            } @else {
                              {{ policyTable.data[0][tableHeader.key] }}
                            }
                          </div>
                        </div>
                      }
                    }
                  </div>
                }
                @case ('horizontal') {
                  <table class="horizontal">
                    <thead>
                      @for (
                        tableHeader of policyTable.headers;
                        track tableHeader.label
                      ) {
                        <th>
                          {{ tableHeader.label }}
                        </th>
                      }
                    </thead>
                    <tbody>
                      @for (tableRow of policyTable.data; track tableRow) {
                        <tr>
                          @for (
                            tableCell of policyTable.headers;
                            track tableCell.key
                          ) {
                            @if (tableRow[tableCell.key] !== '') {
                              <td>
                                {{ tableRow[tableCell.key] }}
                              </td>
                            } @else {
                              <td class="empty-cell"></td>
                            }
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                }
                @case ('vertical') {
                  <table class="vertical">
                    <tbody>
                      @for (
                        tableRow of policyTable.headers;
                        track tableRow.label
                      ) {
                        <tr>
                          <th>{{ tableRow.label }}</th>
                          @if (
                            policyTable.data[0] &&
                            policyTable.data[0][tableRow.key] !== ''
                          ) {
                            <td>{{ policyTable.data[0][tableRow.key] }}</td>
                          } @else {
                            <td class="empty-cell"></td>
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                }
                @case ('policies') {
                  <ul class="policies">
                    @for (policy of policies; track policy.name) {
                      <li class="w-100 policy">
                        <div class="policy-header">
                          <span class="score-icon"
                            ><mat-icon>sort</mat-icon></span
                          >

                          <h4>
                            <span>{{
                              policy.outline?.sections?.ShortName || policy.name
                            }}</span>
                            <span *hasPermission="'!RelevanceHideBridgeScore'">
                              | {{ policy.score }}</span
                            >
                          </h4>

                          <div class="expand-button">
                            <button
                              type="button"
                              mat-icon-button
                              (click)="expand($event)"
                            >
                              <span class="collapsed-content">
                                <mat-icon>expand_circle_down</mat-icon>
                              </span>
                            </button>
                          </div>
                        </div>

                        <div class="policy-body">
                          <div class="row">
                            <app-reason-text
                              class="col-12"
                              [data]="policy.trueRules"
                              [forceNeutral]="true"
                              [tags]="reasonTags"
                            />
                          </div>
                        </div>
                      </li>
                    }
                  </ul>
                }
                @case ('policyHealth') {
                  <div class="ps-3 pe-3 pt-1">
                    <mat-tab-group #tabGroup class="w-100 mb-3">
                      @if (showPolicyReviewTab) {
                        <mat-tab label="Policy Review">
                          <ng-template matTabContent>
                            @if (!policyReview?.length) {
                              <div class="no-chart-data">
                                No Policy Review Items Found
                              </div>
                            } @else {
                              <ul class="policies">
                                @for (
                                  policy of policyReview;
                                  track policy.name
                                ) {
                                  <li class="w-100 policy expanded">
                                    <div class="policy-header">
                                      <span class="score-icon"
                                        ><mat-icon>list_alt</mat-icon></span
                                      >

                                      <h4>
                                        <span>{{
                                          policy.outline?.sections?.ShortName ||
                                            policy.name
                                        }}</span>
                                        <span
                                          *hasPermission="
                                            '!RelevanceHideBridgeScore'
                                          "
                                        >
                                          | {{ policy.score }}</span
                                        >
                                      </h4>
                                    </div>

                                    <div class="policy-body">
                                      <div class="row">
                                        <app-reason-text
                                          class="col-12"
                                          [data]="policy.trueRules"
                                          [forceNeutral]="true"
                                          [tags]="reasonTags"
                                        />
                                      </div>
                                    </div>
                                  </li>
                                }
                              </ul>
                            }
                          </ng-template>
                        </mat-tab>
                      }
                      <mat-tab label="Policy Tags">
                        <ng-template matTabContent>
                          @if (!policies?.length) {
                            <div class="no-chart-data">
                              No Policy Tag Items Found
                            </div>
                          } @else {
                            <ul class="policies">
                              @for (policy of policies; track policy.name) {
                                <li class="w-100 policy">
                                  <div class="policy-header">
                                    <span class="score-icon"
                                      ><mat-icon>sort</mat-icon></span
                                    >
                                    <h4>
                                      <span>{{
                                        policy.outline?.sections?.ShortName ||
                                          policy.name
                                      }}</span>
                                      <span
                                        *hasPermission="
                                          '!RelevanceHideBridgeScore'
                                        "
                                      >
                                        | {{ policy.score }}</span
                                      >
                                    </h4>

                                    <div class="expand-button">
                                      <button
                                        type="button"
                                        mat-icon-button
                                        (click)="expand($event)"
                                      >
                                        <span class="collapsed-content">
                                          <mat-icon
                                            >expand_circle_down</mat-icon
                                          >
                                        </span>
                                      </button>
                                    </div>
                                  </div>

                                  <div class="policy-body">
                                    <div class="row">
                                      <app-reason-text
                                        class="col-12"
                                        [data]="policy.trueRules"
                                        [forceNeutral]="true"
                                        [tags]="reasonTags"
                                      />
                                    </div>
                                  </div>
                                </li>
                              }
                            </ul>
                          }
                        </ng-template>
                      </mat-tab>
                    </mat-tab-group>
                  </div>
                }
                @case ('aiSummary') {
                  <div class="ai-summary-container">
                    @if (aiSummary && !loadingAiSummary && !aiError) {
                      <div
                        class="notes-list ai-summary px-3"
                        [innerHTML]="aiSummary"
                      ></div>
                      <div class="ai-disclaimer px-3 pt-3 w-100">
                        <span>
                          **This is created by generative AI. Results and
                          details should be verified.
                        </span>
                      </div>
                    } @else if (!aiSummary && loadingAiSummary && !aiError) {
                      <div class="px-3 loading-container">
                        <ngx-loading
                          [show]="loadingAiSummary"
                          [config]="{
                            fullScreenBackdrop: false,
                          }"
                        />
                      </div>
                    } @else if (!aiSummary && !loadingAiSummary && aiError) {
                      <div
                        class="ai-summary-error px-3 mb-3"
                        [innerHTML]="aiError"
                      ></div>
                    }
                    @if (
                      (!aiSummary && !loadingAiSummary && !aiError) ||
                      (!aiSummary && !loadingAiSummary && aiError)
                    ) {
                      <div class="px-3">
                        <button
                          type="button"
                          mat-raised-button
                          color="accent"
                          class="w-100"
                          (click)="getAiSummary()"
                        >
                          @if (!aiSummary && !loadingAiSummary && aiError) {
                            <mat-icon>replay</mat-icon>
                          } @else {
                            <mat-icon>auto_awesome</mat-icon>
                          }
                          @if (!aiSummary && !loadingAiSummary && aiError) {
                            Try Again
                          } @else {
                            Analyze Policy
                          }
                        </button>
                      </div>
                    }
                  </div>
                }
              }
            </div>
          }
        </div>
      </div>
    }
  }
</div>

<ngx-loading [show]="loading" />
@if (loading && showUpdateMessage) {
  <span class="policy-loading-text"> Loading policy information... </span>
}
